import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';

@Injectable()
export class ReportsService {
  constructor(
    private http: HttpClient,
  ) {}

  public getUserSessionsWithSiteForms(body) {
    return this.http
      .get(
        environment.apiUrl +
          `api/ext-user-session/report-with-site-form?startDate=${body.startDate}&endDate=${body.endDate}&sort=${body.sort}&size=${body.size}&page=${body.page}&siteFormId=${body.siteFormId}${
            body.siteId ? '&siteId=' + body.siteId : ''
          }`,
        {
          observe: 'response',
        }
      )
      .pipe(map(this.handleDataWithHeaders))
      .pipe(catchError(this.handleError));
  }

  public getWorkerCompetencyAndTrainingReport(siteOwnerId: number) {
    return this.http.get(environment.apiUrl + 'api/reports/competency-training/by-site-owner/' + siteOwnerId)
    .pipe(catchError(this.handleError));
  }

  public getConfinedSpaceCompetencyAndTrainingReport(siteOwnerId: number) {
    return this.http.get(environment.apiUrl + 'api/reports/confined-spaces/by-site-owner/' + siteOwnerId)
    .pipe(catchError(this.handleError));
  }

  public getContractorCompetencyReport(siteOwnerId: number) {
    return this.http.get(environment.apiUrl + 'api/ext-maintenance/maintenance-siteowner-competency/report-maintenance-competency-by-site-owner/' + siteOwnerId)
    .pipe(catchError(this.handleError));
  }

  // Handle Responses
  private handleData(res: HttpResponse<any>) {
    const body = res;
    return body;
  }

  private handleDataWithHeaders(res: HttpResponse<any>) {
    const headers = res.headers;
    const body = res.body;
    const data = {
      headers: headers,
      body: body,
    };
    return data;
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }
}
